import { render } from "./EditVideoModal.vue?vue&type=template&id=f348d08a"
import script from "./EditVideoModal.vue?vue&type=script&lang=js"
export * from "./EditVideoModal.vue?vue&type=script&lang=js"

import "./EditVideoModal.vue?vue&type=style&index=0&id=f348d08a&lang=css"

import exportComponent from "/Users/apple/Desktop/projects/Active Projects/EIEV/Media Dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__